import { Component, type ReactNode } from 'react';

/**
 * Catches render-time exceptions in a tab so one page can't blank the whole admin.
 * Shows the actual error message (so it can be reported) and a Try-again reset.
 */
export class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  override state: { error: Error | null } = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  override componentDidCatch(error: Error, info: unknown) {
    // Surfaced in the browser console for diagnosis.
    console.error('[admin] render error:', error, info);
  }

  override render() {
    if (this.state.error) {
      return (
        <div className="rounded-lg border border-rose-200 bg-rose-50 p-4 text-sm text-rose-700">
          <div className="font-semibold">Something went wrong rendering this view.</div>
          <div className="mt-1 break-words font-mono text-xs">{this.state.error.message}</div>
          <button
            type="button"
            className="mt-3 rounded-md bg-rose-600 px-3 py-1.5 text-xs font-medium text-white hover:bg-rose-700"
            onClick={() => this.setState({ error: null })}
          >
            Try again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
